import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { APPLE_PAY_PROMO, BUSINESS_ACQUIRING, GLOBAL_ACCOUNT, URL_IMAGES_I } from 'constants/UrlConstants';

import { getLangCountryPrefix } from 'helpers/utils';

import CrossProductsAnimateLanding from './CrossProductsAnimateLanding';
import CrossProductsLanding from './CrossProductsLanding';

const RouterCrossProductsLanding = (props) => {
    const [queryMatch, setQueryMatch] = useState(null);
    useEffect(() => {
        const checkWidth = () => {
            if (window && window.matchMedia) {
                let mediaQueryList = window.matchMedia('(max-width: 1351px)');
                setQueryMatch(mediaQueryList.matches);
            }
        };
        checkWidth();
        window.addEventListener('resize', checkWidth);

        return () => {
            window.removeEventListener('resize', checkWidth);
        };
    }, []);

    let pathFirstSlider, pathSecondSlider, imgFirstSlider, imgSecondSlider, logosSecondSlider;
    if (props.showApplePayBanner === true) {
        pathFirstSlider = `${getLangCountryPrefix(props.lang, props.country)}${GLOBAL_ACCOUNT}`;
        pathSecondSlider = `${getLangCountryPrefix(props.lang, props.country)}${APPLE_PAY_PROMO}`;

        imgFirstSlider = (
            <picture>
                <source media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/global-account-2.jpg 1x, ${URL_IMAGES_I}/global-account-2-@2x.jpg 2x`} />
                <source srcSet={`${URL_IMAGES_I}/global-account-2.jpg 1x, ${URL_IMAGES_I}/global-account-2-@2x.jpg 2x`} />
                <img alt="Multi-currency account" src={`${URL_IMAGES_I}/global-account-2.jpg`} loading="lazy" decoding="async" height="288" width="320" />
            </picture>
        );
        imgSecondSlider = (
            <picture>
                <source media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/apple-pay.jpg 1x, ${URL_IMAGES_I}/apple-pay-@2x.jpg 2x`} />
                <source srcSet={`${URL_IMAGES_I}/apple-pay.jpg 1x, ${URL_IMAGES_I}/apple-pay-@2x.jpg 2x`} />
                <img alt="Paysend card, now with Apple Pay" src={`${URL_IMAGES_I}/apple-pay.jpg`} loading="lazy" decoding="async" height="288" width="320" />
            </picture>
        );
        logosSecondSlider = (
            <picture>
                <source media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/pay-logos.jpg 1x, ${URL_IMAGES_I}/pay-logos-@2x.jpg 2x`} />
                <source srcSet={`${URL_IMAGES_I}/pay-logos.jpg 1x, ${URL_IMAGES_I}/pay-logos-@2x.jpg 2x`} />
                <img alt="Paysystem Logos" src={`${URL_IMAGES_I}/pay-logos.jpg`} loading="lazy" decoding="async" height="288" width="320" />
            </picture>
        );
    } else {
        pathFirstSlider = `${getLangCountryPrefix(props.lang, props.country)}${GLOBAL_ACCOUNT}`;
        pathSecondSlider = BUSINESS_ACQUIRING;
        imgFirstSlider = (
            <picture>
                <source media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/global-account-2.jpg 1x, ${URL_IMAGES_I}/global-account-2-@2x.jpg 2x`} />
                <source srcSet={`${URL_IMAGES_I}/global-account-2.jpg 1x, ${URL_IMAGES_I}/global-account-2-@2x.jpg 2x`} />
                <img alt="Multi-currency account" src={`${URL_IMAGES_I}/global-account-2.jpg`} loading="lazy" decoding="async" height="288" width="320" />
            </picture>
        );
        imgSecondSlider = (
            <picture>
                <source media="(min-width: 656px)" srcSet={`${URL_IMAGES_I}/connect.jpg 1x, ${URL_IMAGES_I}/connect-@2x.jpg 2x`} />
                <source srcSet={`${URL_IMAGES_I}/connect.jpg 1x, ${URL_IMAGES_I}/connect-@2x.jpg 2x`} />
                <img alt="Corporate account for companies" src={`${URL_IMAGES_I}/connect.jpg`} loading="lazy" decoding="async" height="288" width="320" />
            </picture>
        );
    }

    const firstText = {
        sliderCrossProdTitle1: props.sliderCrossProdTitle1,
        sliderCrossProdText1: props.sliderCrossProdText1,
        sliderCrossProdTitle2: props.sliderCrossProdTitleApplePromo,
        sliderCrossProdText2: props.sliderCrossProdTextApplePromo,
        learnMore: props.learnMore,
    };

    const secondText = {
        sliderCrossProdTitle1: props.sliderCrossProdTitle1,
        sliderCrossProdText1: props.sliderCrossProdText1,
        sliderCrossProdTitle2: props.sliderCrossProdTitle2,
        sliderCrossProdText2: props.sliderCrossProdText2,
        learnMore: props.learnMore,
    };
    const texts = props.showApplePayBanner ? firstText : secondText;

    return queryMatch ? (
        <CrossProductsAnimateLanding
            pathFirstSlider={pathFirstSlider}
            pathSecondSlider={pathSecondSlider}
            imgFirstSlider={imgFirstSlider}
            imgSecondSlider={imgSecondSlider}
            logosSecondSlider={logosSecondSlider}
            {...texts}
        />
    ) : (
        <CrossProductsLanding
            pathFirstSlider={pathFirstSlider}
            pathSecondSlider={pathSecondSlider}
            imgFirstSlider={imgFirstSlider}
            imgSecondSlider={imgSecondSlider}
            logosSecondSlider={logosSecondSlider}
            {...texts}
        />
    );
};
const mapStateToProps = (state) => {
    return {
        sliderCrossProdTitle1: state.messages.pageMessages.sliderCrossProdTitle1,
        sliderCrossProdText1: state.messages.pageMessages.sliderCrossProdText1,
        sliderCrossProdTitle2: state.messages.pageMessages.sliderCrossProdTitle2,
        sliderCrossProdText2: state.messages.pageMessages.sliderCrossProdText2,
        sliderCrossProdTitleApplePromo: state.messages.pageMessages.sliderCrossProdTitleApplePromo,
        sliderCrossProdTextApplePromo: state.messages.pageMessages.sliderCrossProdTextApplePromo,
        country: state.app.country,
        lang: state.language.lang,
        learnMore: state.extra.geo.learnMore,
        showApplePayBanner: state.extra.showApplePayBanner,
    };
};
RouterCrossProductsLanding.propTypes = {
    sliderCrossProdTitle1: PropTypes.string.isRequired,
    sliderCrossProdText1: PropTypes.string.isRequired,
    sliderCrossProdTitle2: PropTypes.string.isRequired,
    sliderCrossProdText2: PropTypes.string.isRequired,
    sliderCrossProdTitleApplePromo: PropTypes.string.isRequired,
    sliderCrossProdTextApplePromo: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    learnMore: PropTypes.string.isRequired,
    showApplePayBanner: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(RouterCrossProductsLanding);
